<template>
    <div class="flow-patient-icon" v-bind:class="cls"  :title="$t(status)">
        <img/>
        <i class="fa fa-circle w3-black fa-xs"></i>
    </div>
</template>

<script>
    export default {
        name: "PatientStatus",
        props: ['status', 'showMarker'],
        computed: {
            cls() {
                var getCls = () => {
                    switch (this.status) {
                        case "NoBadge":
                            return "flow-icon-no-badge";
                        case "AtWaitingArea":
                            return "flow-icon-waiting";
                        case "LeftWaitingArea":
                            return "flow-icon-left-waiting";
                        case "InConsultation":
                            return "flow-icon-consultation";
                        case "LeavingConsultation":
                            return "flow-icon-leaving";
                        case "LeftConsultation":
                            return "flow-icon-left";
                        default:
                            return "flow-icon-walking"

                    }
                };

                return getCls() + (this.showMarker === true ? " active" : "");
            }
        }
    }
</script>